export { Properties } from "./Properties";
